<template>
  <v-container class="recover-success" fluid>
    <v-row no-gutters>
      <v-col>
        <p class="recover-success-title" :style="{ color: getAssets.colors.form.buttonBackground }">SUCESSO!</p>
        <p class="recover-success-subtitle">Sua senha foi redefinida e agora você já pode acessar seu cadastro a vontade.</p>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-btn
        width="100%"
        :color="getAssets.colors.form.buttonBackground"
        :style="{ color: getAssets.colors.form.buttonFont }"
        class="mb-3 button-height"
        @click="$emit('continue')"
        >Acessar meu cadastro</v-btn
      >
    </v-row>
    <div class="link-container">
      <span class="link" @click="$emit('finish')">Finalizar</span>
    </div>
  </v-container>
</template>

<script>
export default {
  computed: {
    getAssets() {
      return this.$store.getters.GET_ASSETS
    }
  }
}
</script>

<style lang="scss">
$phone-size: 600px;
$tablet-size: 960px;

.recover-success {
  padding: 40px 30px;
  text-align: center;

  &-title {
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 17px !important;
  }

  &-subtitle {
    font-size: 14px;
    color: #6b7580;
    margin: 0 auto 33px !important;
  }

  .link-container {
    text-align: center;

    & .link {
      margin: auto;
      font-size: 14px;
      color: #0079f2;
      cursor: pointer;
    }

    & .link:hover {
      text-decoration: underline;
    }
  }
}

@media screen and (max-width: $tablet-size) {
  .recover-success {
    & .link-container {
      max-width: 100%;
    }
  }
}

@media screen and (min-width: $phone-size) {
  .recover-success {
    text-align: left;

    &-title {
      font-size: 32px;
      margin-bottom: 8px !important;
    }

    &-subtitle {
      margin: 0 0 21px !important;
    }
  }
}
</style>
